module.exports = __webpack_public_path__ + "img/image_1.2c92db2e.jpg";